import { defineRecipe } from '@chakra-ui/react'

export const skeletonRecipe = defineRecipe({
    variants: {
        variant: {
            gsk: {
                '--animate-from': '200%',
                '--animate-to': '-200%',
                '--duration': '7s',
                backgroundImage: 'linear-gradient(270deg,var(--start-color),var(--end-color),var(--end-color),var(--start-color))',
                backgroundSize: '400% 100%',
                animation: 'bg-position var(--duration, 5s) ease-in-out infinite',

                _light: {
                    '--start-color': 'colors.white',
                    '--end-color': 'rgba(84, 79, 64, 0.08)',
                },
                _dark: {
                    '--start-color': 'colors.black',
                    '--end-color': 'colors.dark.700',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'gsk',
    },
})
